import { useLocation } from 'react-router-dom';
import { resolveAdminPageContext } from '../navigation/adminNavigation';
import './PageContextLabel.css';

export function PageEyebrow({ section, label }: { section: string; label: string }) {
  return <div className="page-context-label" aria-label="Page context">{section} / {label}</div>;
}

export default function PageContextLabel() {
  const { pathname } = useLocation();
  const context = resolveAdminPageContext(pathname);
  return context ? <PageEyebrow section={context.section} label={context.label} /> : null;
}
